import { useTranslation } from 'react-i18next'

export default function MyResponsiveBullet(props: any): JSX.Element {
  const { t } = useTranslation()
  return props.elemnts.map((element: any) => (
    <div
      key={element.id}
      className="progressContainer mb-3 flex justify-between gap-4 items-center">
      <h4 className="w-1/4 text-sm mt-1 whitespace-nowrap line-clamp-2 truncate ">
        {t(element.title)}
      </h4>
      <div
        className={`bg-[#F0EDF5] ${+element.percentage <= 40 && 'relative'} w-3/4 rounded-xl h-8`}>
        <div
          className={`h-full ${+element.percentage > 40 && 'relative'}  rounded-l-xl bg-[#6A55A0]`}
          style={{ width: `${element.percentage}%` }} // ✅ Fixed width issue
        >
          <div
            className={`absolute top-2 text-[11px] ${
              +element.percentage <= 40 ? 'text-[#6A55A0]' : 'text-white'
            }   right-2`}>
            {element.placeholder}
          </div>
        </div>
      </div>
    </div>
  ))
}
